import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import AppIcon from '../common/AppIcon';

interface PageHeaderProps {
  title: string;
  actionLabel?: string;
  onAction?: () => void;
  actionIcon?: React.ReactNode;
  actions?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, actionLabel, onAction, actionIcon, actions }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
      <Box sx={{ display: 'inline-block', position: 'relative' }}>
        <Typography variant="h4" sx={{ color: 'grey.900', fontFamily: "'Carattere', cursive", fontSize: '3.5rem', lineHeight: 1.1, position: 'relative', zIndex: 1 }}>
          {title}
        </Typography>
        <Box sx={{
          height: 6,
          borderRadius: 3,
          background: 'linear-gradient(90deg, #B07A8F, #C9A96E)',
          opacity: 0.35,
          width: '85%',
          position: 'absolute',
          bottom: 4,
          left: 0,
        }} />
      </Box>
      {actions ? (
        actions
      ) : actionLabel && onAction && (
        <Button
          variant="contained"
          startIcon={actionIcon || <AppIcon name="add" />}
          onClick={onAction}
        >
          {actionLabel}
        </Button>
      )}
    </Box>
  );
};

export default PageHeader;
